import { useEffect, useState } from 'react';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/ae09fe308286d4fb33f9c45d76fb0fbe.png"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Animated Content */}
      <div className={`relative z-10 text-center px-6 w-full max-w-3xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Fredoka', 'Noto Sans JP', sans-serif", textShadow: '2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000' }}>
          アングリング・アクアティクス
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-4 leading-relaxed">
          釣りとアクアリウムの世界へようこそ
        </p>
        <p className="text-sm sm:text-base text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
          淡水釣りから海水釣りまで、テクニック、道具のレビュー、魚の行動などを中心にカバー。
          様々な種類の魚、水槽のメンテナンス、リラックスできる趣味としての水槽飼育の利点について学びます。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#blog"
            className="px-6 py-3 bg-teal-500 text-white rounded-full font-medium hover:bg-teal-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            ブログを読む
          </a>
          <a
            href="#about"
            className="px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full font-medium hover:bg-white/20 transition-all duration-300 transform hover:scale-105 border-2 border-white/30 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            詳しく見る
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
